import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query"
import {
  getEmailTemplates,
  upsertEmailTemplate,
  deleteEmailTemplateOverride,
  previewEmailTemplate,
} from "../infrastructure/email-template-service"

const listKey = (orgId: string) => ["email-templates", orgId]

export function useEmailTemplates(orgId: string | undefined) {
  return useQuery({
    queryKey: listKey(orgId!),
    queryFn: () => getEmailTemplates(orgId!),
    enabled: !!orgId,
  })
}

export function useUpsertEmailTemplate(orgId: string) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ type, body }: { type: string; body: string }) =>
      upsertEmailTemplate(orgId, type, body),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: listKey(orgId) })
    },
  })
}

export function useDeleteEmailTemplateOverride(orgId: string) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (type: string) => deleteEmailTemplateOverride(orgId, type),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: listKey(orgId) })
    },
  })
}

export function useEmailTemplatePreview(orgId: string) {
  return useMutation({
    mutationFn: ({ type, body }: { type: string; body?: string }) =>
      previewEmailTemplate(orgId, type, body),
  })
}
